import { render, staticRenderFns } from "./company-cell.vue?vue&type=template&id=46ba8718&scoped=true"
import script from "./company-cell.vue?vue&type=script&lang=js"
export * from "./company-cell.vue?vue&type=script&lang=js"
import style0 from "./company-cell.vue?vue&type=style&index=0&id=46ba8718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ba8718",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/practice/company/company-cell.vue
// module id = null
// module chunks = 